module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetLow@2x.eff69af.webp";